import Modal from 'tio-ui/components/modal';
import Footer from 'tio-ui/components/footer';
import { t } from 'ember-intl';
import { htmlSafe } from '@ember/template';
import Table from 'tio-ui/components/table';
import type { TOC } from '@ember/component/template-only';

interface GuidelinesModalSignature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
  };
}

const GuidelinesModal: TOC<GuidelinesModalSignature> = <template>
  <Modal @isOpen={{@isOpen}} @onClose={{@onClose}} @size="lg">
    <:header><span class="app-rich-text">{{htmlSafe
          (t "tas.course_cash_guidelines.modal_title")
        }}</span></:header>
    <:body>
      <div class="space-y-6">
        <p class="text-sm app-rich-text">{{htmlSafe (t "tas.course_cash_guidelines.intro")}}</p>

        <hr class="tio-border-default" />

        <div>
          <h3 class="tio-text-lg-semibold mb-3">
            {{t "tas.course_cash_guidelines.section_1_title"}}
          </h3>
          <p class="text-sm mb-3 app-rich-text">{{htmlSafe
              (t "tas.course_cash_guidelines.section_1_text")
            }}</p>
          <ul class="list-disc pl-6 space-y-1 text-sm">
            <li>{{t "tas.course_cash_guidelines.card_detail_1"}}</li>
            <li>{{t "tas.course_cash_guidelines.card_detail_2"}}</li>
            <li>{{t "tas.course_cash_guidelines.card_detail_3"}}</li>
            <li>{{t "tas.course_cash_guidelines.card_detail_4"}}</li>
            <li>{{t "tas.course_cash_guidelines.card_detail_5"}}</li>
          </ul>
        </div>

        <hr class="tio-border-default" />

        <div>
          <h3 class="tio-text-lg-semibold mb-3 app-rich-text">
            {{htmlSafe (t "tas.course_cash_guidelines.section_2_title")}}
          </h3>
          <p class="text-sm mb-4 app-rich-text">{{htmlSafe
              (t "tas.course_cash_guidelines.section_2_text")
            }}</p>

          <Table @isLoading={{false}}>
            <:thead as |options|>
              <options.tr>
                <options.th>{{t "tas.course_cash_guidelines.table_header_step"}}</options.th>
                <options.th>{{t "tas.course_cash_guidelines.table_header_action"}}</options.th>
              </options.tr>
            </:thead>
            <:tbody as |options|>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_1_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_1_action")
                    }}</span>
                </options.td>
              </options.tr>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_2_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_2_action")
                    }}</span>
                </options.td>
              </options.tr>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_3_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_3_action")
                    }}</span>
                </options.td>
              </options.tr>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_4_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_4_action")
                    }}</span>
                </options.td>
              </options.tr>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_5_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_5_action")
                    }}</span>
                </options.td>
              </options.tr>
              <options.tr>
                <options.td class="font-medium">
                  {{t "tas.course_cash_guidelines.step_6_label"}}
                </options.td>
                <options.td>
                  <span class="app-rich-text">{{htmlSafe
                      (t "tas.course_cash_guidelines.step_6_action")
                    }}</span>
                </options.td>
              </options.tr>
            </:tbody>
          </Table>
        </div>
      </div>
    </:body>
    <:footer>
      <Footer @onSubmit={{@onClose}} @submitText={{t "common.close"}} />
    </:footer>
  </Modal>
</template>;

export default GuidelinesModal;
